import app from '../../common/app';
import type Mithril from 'mithril';
import User from '../../common/models/User';

/**
 * The `username` helper displays a user's username in a <span className="username">
 * tag. If the user doesn't exist, the username will be displayed as [deleted].
 */
export default function signName(user: User | null | undefined | false): Mithril.Vnode {
  const name = (user && user.signName()) || app.translator.trans('dl-person.forum.signName_empty');

  return <span className="username">{name}</span>;
}
